import axios from '../../core/services/axios';
// eslint-disable-next-line import/prefer-default-export
export const getOrganizations = () => axios.get('/api/organizations', {
  params: {
    page: 1,
    perPage: 999,
  },
});

/**
 * With organization_id
 * @param {number} initiativeId
 * @param {Object} params
 * @returns {Promise}
 */
export const getRegistrationForms = (initiativeId, params) => axios.get(`/api/initiatives/${initiativeId}/registration-forms/`, {
  params: {
    page: 1,
    perPage: 999,
    ...params,
  },
});
